import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const profileSchema = z.object({
  profileId: z.number(),
  countryCode: z.string(),
  currencyCode: z.string(),
  timezone: z.string(),
  accountInfo: z.object({
    marketplaceStringId: z.string(),
    id: z.string(),
    type: z.string(),
    name: z.string(),
    validPaymentMethod: z.boolean(),
  }),
});

const inaccessibleProfilesResponseSchema = z.object({
  profiles_missing_write_access: z.array(profileSchema),
  profiles_with_invalid_payment_methods: z.array(profileSchema),
});

export const profilesApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getMissingAdvertisingProfiles",
    method: "get",
    path: "/debug_missing_ads_profiles",
    status: 200,
    response: inaccessibleProfilesResponseSchema,
  }).build(),
);
